import React, { useEffect, useState } from 'react'
import Card from '../../../Base/Components/Card/Card'
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid'
import { ListRequisasPendienteDespachoMantenimiento } from '../../../API/Mantenimiento/Requisas/RequisasMantenimientoRequests'
import { Button, Tag } from 'primereact'
import { color5 } from '../../../Styles/Colors'

const RequisasMaterialesPendientesDespachoScreen = () => {

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    const t = await ListRequisasPendienteDespachoMantenimiento();
    setList(t);
    setLoading(false);
  }

  const estadoTemplate = (rowData) => {
    switch (rowData.StatusName) {
      case 'Pendiente Autorizar':
        return <Tag className='col-12' value={rowData.StatusName} style={{ background: color5 }} />

      case 'Pendiente Despacho':
        return <Tag severity='success' className='col-12' value={rowData.StatusName} />
      case 'En Firma':
        return <Tag severity='info' className='col-12' value={rowData.StatusName} />

      default:
        break;
    }
    return <div>{rowData.StatusName}</div>
  }

  const colums = [
    {
      header: 'Fecha',
      field: 'FechaF',
      Format: 'DateTime',
    },
    {
      header: 'Requisa',
      field: 'Requisa',
      className: 'Xsmall',
      frozen: true
    },
    {
      header: 'Estado',
      field: 'StatusName',
      className: 'medium',
      frozen: true,
      Format: 'Template',
      body: estadoTemplate
    },
    {
      header: 'Codigo Producto',
      field: 'CodigoProducto',
      className: 'small',
      frozen: true
    },
    {
      header: 'Producto',
      field: 'NombreProducto',
      className: 'Xlarge',
      frozen: true,
      Sumary: 'count'
    },
    {
      header: 'Descripcion',
      field: 'Descripcion',
      className: 'Xlarge'
    },
    {
      header: 'Unit',
      field: 'UnitName',
      className: 'Xsmall',
      frozen: true,
      alignFrozen: 'right',
    },

    {
      header: 'Solicitado',
      field: 'Qty',
      Format: 'Decimal',
      className: 'small',
      Sumary: 'sum',
      frozen: true,
      alignFrozen: 'right',
    },
    {
      header: 'Inventario',
      field: 'Inventario',
      className: 'small',
      Format: 'Decimal',
      Sumary: 'sum'
    },
    // {
    //   header: 'Comentarios',
    //   field: 'Comentarios',
    //   className: 'large'
    // },
    {
      header: 'Area',
      field: 'Area',
    },
    {
      header: 'Solicita',
      field: 'Solicita',
    },
    // {
    //   header: 'NombreConcatTecD',
    //   field: 'NombreConcatTecD',
    // },
    // {
    //   header: 'TecnicoConcat',
    //   field: 'TecnicoConcat',
    // },
    // {
    //   header: 'AreaGeneral',
    //   field: 'AreaGeneral',
    // },
    // {
    //   header: 'Autoriza',
    //   field: 'UsuarioPermiso1',
    //   className: 'small'
    // },
    // {
    //   header: 'Fecha Solicita',
    //   field: 'FechaPermiso1',
    //   Format: 'DateTime'
    // },
    // {
    //   header: 'Recibe',
    //   field: 'UsuarioPermiso2',
    //   className: 'small',
    // },
    // {
    //   header: 'Fecha Recibe',
    //   field: 'FechaPermiso2',
    //   Format: 'DateTime'
    // },

    // {
    //   header: 'Precio L',
    //   field: 'PrecioL',
    //   className: 'small',
    //   Format: 'Decimal',
    //   Sumary: 'sum'
    // },
    // {
    //   header: 'Precio $',
    //   field: 'PrecioD',
    //   className: 'small',
    //   Format: 'Decimal',
    //   Sumary: 'sum'
    // },
    // {
    //   header: 'Total L',
    //   field: 'TotalL',
    //   className: 'small',
    //   Format: 'Decimal',
    //   Sumary: 'sum',
    //   frozen: true,
    //   alignFrozen: 'right',
    // },
    // {
    //   header: 'Total $',
    //   field: 'TotalD',
    //   className: 'small',
    //   Format: 'Decimal',
    //   Sumary: 'sum',
    //   frozen: true,
    //   alignFrozen: 'right',
    // },

  ]

  const table = {
    Columns: colums,
    Data: list,
    loading: loading
  }

  useEffect(() => {
    getInfo()
    setInterval(() => {
      getInfo()
    }, 60000);
  }, [])

  return (
    <div className='m-3'>
      <Card
        titulo={<div className='d-flex flex-row'>
          <h3>Pendiente de despacho</h3>
          <Button icon='pi pi-refresh' className='ms-2' loading={loading} onClick={getInfo} />
        </div>}
        contenido={<div className='pt-4' style={{ height: '90vh' }}>
          <AgGrid table={table} />
        </div>}
      />
    </div>
  )
}

export default RequisasMaterialesPendientesDespachoScreen